<template>
  <div class="home">
    <NavHeader ></NavHeader>
    <div class="main">
      <keep-alive >
        <router-view v-if="!$route.meta.noAlive"></router-view>
      </keep-alive>
        <router-view v-if="$route.meta.noAlive"></router-view>

    </div>
    <Myfooter></Myfooter>
  </div>
</template>

<script>
// @ is an alias to /src
import NavHeader from "@/components/navHeader/navHeader.vue";

import Myfooter from "@/components/myFooter/myFooter.vue";

export default {
  name: "Home",
  components: {
    NavHeader,
    Myfooter,
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
    
  },
};
</script>
<style lang="scss">
.main {
  // background: url('../assets/index/loginBg.png') no-repeat 100% 100%;
  // width: 100%;
  // height: 100vh;
  // padding: 0.5rem 3rem .125rem 3rem;
  padding: 80px 360px 20px;
  min-height: 90vh;
  background: #F4F7FA;
}
</style>
